export const DIALOG_NAME = 'Dialog';
export const PORTAL_NAME = 'DialogPortal';
export const OVERLAY_NAME = 'DialogOverlay';
export const CONTENT_NAME = 'DialogContent';
export const CLOSE_NAME = 'DialogClose';
export const TRIGGER_NAME = 'DialogTrigger';
export const DESCRIPTION_NAME = 'DialogDescription';